import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import React from 'react';
import styled from 'styled-components';
import ProjectListSection from './ProjectListSection';
import ProjectsContext from './ProjectsContext';
import ProjectsListHeader from './ProjectsListHeader';
// import ProjectLookup from '../projectLookup/ProjectLookup';
import ProjectSelection from './ProjectSelection';

const ProjectListHeaderContainer = styled.div`
    padding-left:10px;
    display:flex;
    height:50px;
    justify-content:center;
    padding-right:10px;
`;

const ProjectListSearchContainer = styled.div`
    margin-right: 10px;
`;

class ProjectsList extends React.Component {
    
    static contextType = ProjectsContext;
    constructor(props)
    {
        super(props);
        this.state = {projectToSearch:null};
    }


    render()
    {
        const {gbus = [], selectedProjectOrGbu} = this.context.reduxStore;

        // If there's a selected project, only show the GBU that contains it
        let gbusToShow = gbus;
        if (selectedProjectOrGbu && !selectedProjectOrGbu.isGbu) {
            // Find the GBU that contains the selected project
            gbusToShow = gbus.filter(gbu => 
                gbu.projects && gbu.projects.some(project => project.id === selectedProjectOrGbu.id)
            );
        } else if (selectedProjectOrGbu && selectedProjectOrGbu.isGbu) {
            // If a GBU is selected, only show that GBU
            gbusToShow = gbus.filter(gbu => gbu.id === selectedProjectOrGbu.id);
        }

        return(<List>
            <ProjectListHeaderContainer>
                <ProjectsListHeader/>
            </ProjectListHeaderContainer>
            <Divider/>
            <ProjectListSearchContainer>
                <ProjectSelection/>
                {/* <ProjectLookup onProjectSelected={projectToSearch=>this.setState({projectToSearch})} selectedProject={this.state.projectToSearch} /> */}
            </ProjectListSearchContainer>
            <Divider/>
            {!this.state.projectToSearch && gbusToShow && gbusToShow.map && gbusToShow.map((gbu,index) => <ProjectListSection gbu={gbu} key={index}/>)}
        </List>)    
    }
}

export default ProjectsList;